export default "__VITE_ASSET__Lq2YCCuW__"